export const allowMembershipRequest = {
  LOGGED_USERS: 'logged_users',
  DISABLED: 'disabled'
}

export const allowMembershipRequest_options = {
  [allowMembershipRequest.LOGGED_USERS]:"enums:allowMembershipRequest_option_logged_users",
  [allowMembershipRequest.DISABLED]:"enums:allowMembershipRequest_option_disabled",
}
